// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"07ccb504","498":"77614231","703":"d21cf2f0"}[chunkId] + ".chunk.js";
};